export default __webpack_public_path__ + "static/media/network.25ab6a63.svg";